import React, { Component, Fragment } from 'react';

import { MContext } from '../../common/HelpProvider';

export default class BrandDetailsHelp extends Component {

    constructor(props) {
        super(props);
    }

    static get FocusType() {
        return {
            NONE: null,
            BRAND_TITLE: 'title',
            DESIGNER_NAME: 'name',
            TAGLINE: 'tagline',
            DESCRIPTION: 'desc',
            LOGO: 'logo',
            PORTRAIT: 'portrait',
            STORY: 'story',
        };
    }

    renderInitalPageHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Brand Showcase</h5>
                </div>
            </Fragment>
        );
    }

    renderBrandTitleHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_title_0nMeb8Oza" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Brand Showcase</h5>
                </div>
            </Fragment>
        );
    }

    renderDesignerNameHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/designer_name_D5VzUZYFF" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Designer Name/(s)</h5>
                </div>
            </Fragment>
        );
    }

    renderTaglineHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_tag_65zosXT0n" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5 className="mt-4">Tip: Brand Tagline</h5>
                </div>
            </Fragment>
        );
    }

    renderDescHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_desc_fW_w9HXj-.jpg" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Brand Description</h5>
                </div>
            </Fragment>
        );
    }

    renderLogoHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_logo_FHFEnsqHp.jpg" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Brand Logo</h5>
                </div>
            </Fragment>
        );
    }

    renderPortraitHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_portrait_5vuFnbmHN" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Designer Portrait</h5>
                </div>
            </Fragment>
        );
    }

    renderStoryHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://res.cloudinary.com/flairfashion/image/upload/c_scale,f_auto,h_500,q_auto:best/v1625662320/DesignerPortal/Tips/dsigner-details1.jpg" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Brand Story</h5>
                </div>
            </Fragment>
        );
    }

    renderStoryHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://res.cloudinary.com/flairfashion/image/upload/c_scale,f_auto,h_500,q_auto:best/v1625662320/DesignerPortal/Tips/dsigner-details1.jpg" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: University</h5>
                </div>
            </Fragment>
        );
    }

    render() {
        const { focus } = this.props;
        return (
            <div className="sticky-top pt-5">
                <MContext.Consumer>
                    {(context) => (
                        <div>
                            {context.state.help === BrandDetailsHelp.FocusType.NONE &&
                                this.renderInitalPageHelp()
                            }
                            {context.state.help === BrandDetailsHelp.FocusType.BRAND_TITLE &&
                                this.renderBrandTitleHelp()
                            }
                            {context.state.help === BrandDetailsHelp.FocusType.DESIGNER_NAME &&
                                this.renderDesignerNameHelp()
                            }
                            {context.state.help === BrandDetailsHelp.FocusType.TAGLINE &&
                                this.renderTaglineHelp()
                            }
                            {context.state.help === BrandDetailsHelp.FocusType.DESCRIPTION &&
                                this.renderDescHelp()
                            }
                            {context.state.help === BrandDetailsHelp.FocusType.LOGO &&
                                this.renderLogoHelp()
                            }
                            {context.state.help === BrandDetailsHelp.FocusType.PORTRAIT &&
                                this.renderPortraitHelp()
                            }
                            {context.state.help === BrandDetailsHelp.FocusType.STORY &&
                                this.renderStoryHelp()
                            }
                        </div>
                    )}
                </MContext.Consumer>
            </div>
        );
    }
}

